import { render, staticRenderFns } from "./ListManifestosComponent.vue?vue&type=template&id=7b56a807&scoped=true&"
import script from "./ListManifestosComponent.vue?vue&type=script&lang=js&"
export * from "./ListManifestosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b56a807",
  null
  
)

export default component.exports